module.exports = __webpack_public_path__ + "img/s4_img.b6c92903.png";